export interface SerializedScreenSize {
  maxWidth: number;
  minWidth: number;
}

export default class ScreenSize {
  minWidth: number;

  maxWidth: number;

  constructor({ minWidth, maxWidth }: { maxWidth: number; minWidth: number }) {
    this.minWidth = minWidth;
    this.maxWidth = maxWidth;
  }

  includes(width?: number): boolean {
    return !!width && width >= this.minWidth && width <= this.maxWidth;
  }

  get cssMinWidth(): string {
    return `${this.minWidth}px`;
  }

  get cssMaxWidth(): string {
    if (this.maxWidth === Infinity) {
      return '999999999px';
    }

    return `${this.maxWidth}px`;
  }

  toJSON(): SerializedScreenSize {
    return {
      maxWidth: this.maxWidth,
      minWidth: this.minWidth,
    };
  }
}
